var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"6","height":"8","viewBox":"0 0 6 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.66675 6.66668L4.33341 4.00001L1.66675 1.33334","stroke":"#F8F8F6","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }